// General
import "./dashboard.scss";

const Dashboard = () => {
  return (
    <div id="dashboard-page">
      <h1>Dashboard</h1>
    </div>
  );
};

export default Dashboard;